
import { FormPage } from "../../types/form";

export const page2Config: FormPage = {
  page: 2,
  elements: [
    {
      id: "section_teaching_info",
      type: "section_header",
      label: "formFields.page2.sectionTeachingInfo"
    },
    {
      id: "previous_report_button",
      type: "previous_report_button",
      label: "formFields.page2.previousReportBtn",
      name: "previous_report_button",
    },
    {
      id: "location",
      type: "radio",
      label: "formFields.page2.locationLabel",
      name: "teaching_location",
      required: true,
      options: [
        { value: "online", label: "formFields.page2.locationOnline" },
        { value: "siam", label: "formFields.page2.locationSiam" },
        { value: "ngamwongwan", label: "formFields.page2.locationNgamwongwan" }
      ]
    },
    {
      id: "teaching_type",
      type: "select",
      label: "formFields.page2.teachingTypeLabel",
      name: "teaching_type",
      required: false,
      options: [
        { value: "Private มีชีท = คุณครูใช้ชีทตัวเอง", label: "formFields.page2.teachingTypePrivWith" },
        { value: "Private ไม่มีชีท = คุณครูใช้ชีทของสถาบัน (ชีทภาษาไทย)", label: "formFields.page2.teachingTypePrivWithout" },
        { value: "Premier_TH ไม่มีชีท = คุณครูใช้ชีทของสถาบัน", label: "formFields.page2.teachingTypePremTHWithout" },
        { value: "Premier_TH มีชีท = คุณครูใช้ชีทตัวเอง/ชีทน้อง (ชีทภาษาไทย)", label: "formFields.page2.teachingTypePremTHWith" },
        { value: "Premier_Inter ไม่มีชีท = คุณครูใช้ชีทของสถาบัน (ชีทภาษาอังกฤษ)", label: "formFields.page2.teachingTypePremINWithout" },
        { value: "Premier_Inter มีชีท = คุณครูใช้ชีทตัวเอง/ชีทน้อง (ชีทภาษาอังกฤษ)", label: "formFields.page2.teachingTypePremINWith" }
      ],
      placeholder: "formFields.page2.teachingTypePlaceholder"
    },
    {
      id: "teaching_date",
      type: "date",
      label: "formFields.page2.teachingDateLabel",
      name: "teaching_date",
      required: true,
      description: "formFields.page2.teachingDateDesc"
    },
    {
      id: "time_slot",
      type: "time_picker",
      label: "formFields.page2.timeSlotLabel",
      name: "teaching_time_slot",
      required: true,
      description: "formFields.page2.timeSlotDesc"
    },
    {
      id: "duration",
      type: "radio",
      label: "formFields.page2.durationLabel",
      name: "teaching_duration",
      required: true,
      options: [
        { value: "30 นาที", label: "formFields.page2.duration30m" },
        { value: "1 ชม.", label: "formFields.page2.duration1h" },
        { value: "1.30 ชม.", label: "formFields.page2.duration1h30" },
        { value: "2 ชม.", label: "formFields.page2.duration2h" },
        { value: "2.30 ชม.", label: "formFields.page2.duration2h30" },
        { value: "3 ชม.", label: "formFields.page2.duration3h" },
        { value: "4 ชม.", label: "formFields.page2.duration4h" }
      ]
    },
    {
      id: "student_search",
      type: "student_search",
      label: "formFields.page2.studentSearchLabel",
      name: "student_search",
      required: false,
      description: "formFields.page2.studentSearchDesc"
    },
    {
      id: "student_fullname",
      type: "text",
      label: "formFields.page2.studentFullnameLabel",
      name: "student_full_name",
      required: false,
      readOnly: true
    },
    {
      id: "student_nickname",
      type: "text",
      label: "formFields.page2.studentNicknameLabel",
      name: "student_nickname",
      required: false,
      readOnly: true
    },
    {
      id: "student_id",
      type: "text",
      label: "formFields.page2.studentIdLabel",
      name: "student_id",
      required: false,
      readOnly: true
    },
    {
      id: "student_grade",
      type: "select",
      label: "formFields.page2.gradeLabel",
      name: "student_grade_level",
      required: true,
      options: [
        { value: "ป.1", label: "formFields.page2.gradeP1" },
        { value: "ป.2", label: "formFields.page2.gradeP2" },
        { value: "ป.3", label: "formFields.page2.gradeP3" },
        { value: "ป.4", label: "formFields.page2.gradeP4" },
        { value: "ป.5", label: "formFields.page2.gradeP5" },
        { value: "ป.6", label: "formFields.page2.gradeP6" },
        { value: "ม.1", label: "formFields.page2.gradeM1" },
        { value: "ม.2", label: "formFields.page2.gradeM2" },
        { value: "ม.3", label: "formFields.page2.gradeM3" },
        { value: "ม.4", label: "formFields.page2.gradeM4" },
        { value: "ม.5", label: "formFields.page2.gradeM5" },
        { value: "ม.6", label: "formFields.page2.gradeM6" }
      ],
      placeholder: "formFields.page2.gradePlaceholder"
    },
    {
      id: "subject",
      type: "radio",
      label: "formFields.page2.subjectLabel",
      name: "subject",
      required: true,
      options: [
        { value: "วิทยาศาสตร์", label: "formFields.page2.subjectScience" },
        { value: "คณิตศาสตร์", label: "formFields.page2.subjectMath" },
        { value: "ฟิสิกส์", label: "formFields.page2.subjectPhysics" },
        { value: "เคมี", label: "formFields.page2.subjectChemistry" },
        { value: "ชีวะ", label: "formFields.page2.subjectBiology" },
        { value: "สังคม", label: "formFields.page2.subjectSocial" },
        { value: "ภาษาไทย", label: "formFields.page2.subjectThai" },
        { value: "ภาษาอังกฤษ", label: "formFields.page2.subjectEnglish" },
        { value: "ภาษาจีน", label: "formFields.page2.subjectChinese" },
        { value: "ประวัติศาสตร์", label: "formFields.page2.subjectHistory" }
      ]
    },
    {
      id: "learning_status",
      type: "radio",
      label: "formFields.page2.learningStatusLabel",
      name: "learning_status",
      required: true,
      options: [
        { value: "เข้าเรียน/เข้าสอนปกติ", label: "formFields.page2.statusNormal" },
        { value: "น้องไม่เข้าเรียน (ลากะทันหัน)", label: "formFields.page2.statusAbsent" }
      ]
    },
    {
      id: "checkin_photo",
      type: "file",
      label: "formFields.page2.checkinPhotoLabel",
      name: "check_in_photo_urls",
      required: true,
      description: "formFields.page2.checkinPhotoDesc",
      validation: {
        maxFiles: 1,
        maxSizeMB: 5
      }
    }
  ]
};
